export default "__VITE_ASSET__DQ_ArroK__"